import { useEffect, useState } from 'react';
import { GetCmsObjectsByType } from '../../CMSManagement/CMS_api';
import { CMS_OBJECT_TYPES } from '../../CMS_Constants';
import Base from '../../../Base/Base';
import { theme } from '../../../../components/layouts/theme';
import { ThemeProvider } from '@mui/material/styles';
import styles from './RoleDescriptions.module.scss';
import { GetApplicationsInfoDetails } from '../../../ApplicationInformation/ApplicationInformation_api';
import { DataTable } from '../../../../components/UI/MDC/DataTable/DataTable';
import { EPIC_LINK_APP_ID } from 'pages/ApplicationRequest/components/containers/1617BridgesLink/_const';

const DO_NOT_ALPHABETIZE = [EPIC_LINK_APP_ID];

const RoleDescriptions = () => {
	const appID = new URLSearchParams(window.location.search).get('appID');
	const [isLoading, setIsLoading] = useState(true);
	const [appInfo, setAppInfo] = useState(null);
	const [roles, setRoles] = useState([]);
	useEffect(() => {
		GetCmsObjectsByType(CMS_OBJECT_TYPES.RoleDescriptions.name)
			.then(response => {
				//get the CMS object that has a value that matches the appID of the query parameter in the Field with content type IMS-App
				let roleDescriptions = response.data.find(rd => {
					let field = rd?.Fields?.find(
						f => f.FieldDefinition.ContentType === 'IMS-App'
					);
					return field.Value === appID;
				});

				let roleObj = null;
				try {
					roleObj = JSON.parse(
						roleDescriptions?.Fields.find(
							field =>
								field.FieldDefinition.ContentType ===
								'IMS-App-Roles'
						)?.Value
					);

					//conditionally alphabetize by role
					if (
						DO_NOT_ALPHABETIZE.some(id => id.toString() === appID)
					) {
						setRoles(roleObj);
					} else {
						let sortedRoles = roleObj.sort(function (a, b) {
							const roleA = a.role.toUpperCase();
							const roleB = b.role.toUpperCase();
							return roleA < roleB ? -1 : roleA > roleB ? 1 : 0;
						});

						setRoles(sortedRoles);
					}
				} catch (ex) {
					// if JSON.parse throws an error, setRoles to null
					setRoles(null);
				}
			})
			.then(x => {
				//get the selected applications information (app name, etc)
				GetApplicationsInfoDetails(appID).then(response => {
					setAppInfo(response.applications[0]?.appInfo);
				});
			})
			.then(x => {
				setIsLoading(false);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const headers = [
		{ Value: 'Role', props: { sort: null, onSortChange: null } },
		{ Value: 'Description', props: { sort: null, onSortChange: null } },
	];

	const rows = roles?.map(role => {
		return {
			Cells: {
				Role: {
					Value: role.role,
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
				Description: {
					Value: (
						<p className={styles.DescriptionWrap}>
							{role.description}
						</p>
					),
					Validation: {
						Key: 'true',
						Value: null,
						memberToValidateKey: null,
					},
				},
			},
			Key: role.id,
		};
	});

	return (
		<ThemeProvider theme={theme}>
			<Base
				title='Role Descriptions'
				loading={isLoading}
				className={styles.APPLY_FONT}
			>
				<div className={styles.SelectedAppHeader}>
					<h3>{appInfo?.applicationName}</h3>
				</div>
				{roles === null ? (
					<p>
						No Role Description Page has been created for this
						application.
					</p>
				) : (
					<DataTable
						rows={rows}
						headers={headers}
						stickyColumns={1}
						className={styles.Table_Overrides}
					/>
				)}
			</Base>
		</ThemeProvider>
	);
};

export default RoleDescriptions;
